<script type="text/ecmascript-6">
    import TileQuestion from "../mixin/TileQuestion.vue";
    import DesignerQuestionDoorColourExternal from "../DesignerQuestionDoorColourExternal.vue";

    export default {
        mixins: [
            DesignerQuestionDoorColourExternal,
            TileQuestion
        ],
    }
</script>
